import { css } from '@emotion/core';
import { MultiselectField, useForm } from '@weave/design-system';
import { HistorySettingsPageEnum } from 'components/history-list-container/table-configs';
import React, { useEffect } from 'react';

interface IHistoryListDropdownProps {
  options: string[];
  label: string;
  placeholder: string;
  listType?: HistorySettingsPageEnum;
  onDropdownSelect?: (selected: string[]) => void;
}

export const HistoryListDropdown = ({
  options,
  label,
  placeholder,
  listType,
  onDropdownSelect = () => {},
}: IHistoryListDropdownProps) => {
  const { getFieldProps, values } = useForm({
    fields: {
      sourceId: {
        type: 'multiselect',
      },
    },
  });

  const isDropdownVisible =
    listType === HistorySettingsPageEnum.CLIENT_LOCATIONS ||
    listType === HistorySettingsPageEnum.APPOINTMENT_CONFIRMATION_WRITEBACKS ||
    listType === HistorySettingsPageEnum.SYNC_APP_WRITEBACKS;

  useEffect(() => {
    onDropdownSelect(values['sourceId'] as string[]);
  }, [values['sourceId']]);

  if (!isDropdownVisible) {
    return null;
  }

  return (
    <>
      <MultiselectField
        {...getFieldProps('sourceId')}
        label={label}
        placeholder={placeholder}
        value={getFieldProps('sourceId').value || []}
        css={css`
          max-width: 500px;
        `}
      >
        {options?.map((option) => (
          <MultiselectField.Option key={option} value={option}>
            {option}
          </MultiselectField.Option>
        ))}
      </MultiselectField>
    </>
  );
};
